export default __webpack_public_path__ + "static/media/blackHamburgerIcon.926d57d1.svg";